module.exports = __webpack_public_path__ + "img/Penny-Tote-05.0f254e64.jpg";